import { BREAK_POINT, IS_ACTIVE } from "./_defs";
import { MouseStalker } from "./classes/_MouseStalker";
import { getPcFullSize, getSpSize } from "./functions/_getSize";
import { getTarget } from "./functions/_getTarget";
import { hideCover, onHideCover } from "./functions/_hideCover";
import { setupAnchorScroll } from "./modules/_acnrhoScroll";
import { setupContents } from "./modules/_contents";
import { setupCssValue } from "./modules/_cssValues";
import {
  autoOpenDialog,
  getDialog,
  openDialog,
  setupDialog
} from "./modules/_dialog";
import { setupFooter } from "./modules/_footer";
import { setupInView } from "./modules/_inView";
import { setupKv } from "./modules/_kv";
import { setupMenu } from "./modules/_menu";
import { mobileQuery } from "./modules/_mobileQuery";
import { setupSticky } from "./modules/_sticky";
import { setupTab } from "./modules/_tab";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

setupCssValue();
setupMenu();
setupAnchorScroll();
setupKv();
setupDialog();
setupTab();
setupContents();
setupFooter();

window.addEventListener("load", () => {
  setupSticky();
  setupInView();
  hideCover();
});

const siteObject = {
  BREAK_POINT,
  IS_ACTIVE,
  mobileQuery,
  MouseStalker,
  getPcFullSize,
  getSpSize,
  getTarget,
  getDialog,
  openDialog,
  autoOpenDialog,
  onHideCover
};

declare global {
  const site: typeof siteObject;
  interface Window {
    site: typeof siteObject;
  }
}

window.site = siteObject;
